import { render, staticRenderFns } from "./examQuestions.html?vue&type=template&id=4e6fc3ff&external"
import script from "./examQuestions.vue?vue&type=script&lang=js"
export * from "./examQuestions.vue?vue&type=script&lang=js"
import style0 from "./examQuestions.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports